import { useParams } from "react-router-dom";
import { useCallback, useState } from "react";
import { Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import ComponentFormDialog from "./ComponentFormDialog";
import { saveComponent } from "features/campaigns/services/componentService";
import { useSelectedProject } from "Hooks";
import produce from "immer";
import { ApiSimpleComponent, ApiComponentBlockCategory } from "@incendium/api";
import { CallbackOrVal } from "Interfaces";

interface ILanderBreadcrumbProps {
    component: ApiSimpleComponent | null;
    setComponent: (v: CallbackOrVal<ApiSimpleComponent>) => void;
    setComponents: (v: CallbackOrVal<ApiSimpleComponent[]>) => void;
}

function LanderBreadcrumb({ component, setComponent, setComponents }: ILanderBreadcrumbProps) {
    const { componentId } = useParams<{ componentId: string }>();
    const { selectedProject } = useSelectedProject();
    const [isOpen, setIsOpen] = useState(false);


    const handleClick = useCallback(() => {
        setIsOpen(true);
    }, []);

    const handleClose = useCallback(() => {
        setIsOpen(false);
    }, []);

    const onSaved = useCallback(async (name: string, description: string, category?: ApiComponentBlockCategory) => {
        if (!component || !selectedProject?.id) return;

        await saveComponent(selectedProject.id, {
            ...component,
            name,
            description,
            category
        });

        setComponent(component => ({
            ...component,
            name,
            description,
            category
        }));

        setComponents(components => produce(components, draft => {
            const index = draft.findIndex(t => t.id === component.id);
            if (index !== -1) {
                draft[index].name = name;
                draft[index].description = description;
                draft[index].category = category;
            }
        }));

        handleClose();
    }, [component, selectedProject?.id, setComponent, setComponents, handleClose]);

    if (!component) {
        return <>{componentId}</>;
    }

    return (
        <>
            <Typography
                onClick={handleClick}
                color="primary"
                variant="body1"
                noWrap
                sx={{ cursor: 'pointer', display: 'flex', alignItems: 'center', zIndex: 1 }}
            >
                {component.name}
                <Edit fontSize="small" sx={{ ml: 0.5 }} />
            </Typography>
            <ComponentFormDialog
                open={isOpen}
                setOpen={setIsOpen}
                onSaved={onSaved}
                name={component.name}
                description={component.description}
                category={component.category}
            />
        </>
    );
}

export default LanderBreadcrumb;